<div class="user-management-container">
  <p class="air-heading">User Management User ID/Roles</p>  <np-tabbed>
    <ul class="tabs">
      <li role="tab" aria-selected="true" (click)="clearSearchUserId()">User User ID/Roles</li>
      <li role="tab" aria-selected="false" (click)="clearUserId()">Add New User</li>
    </ul>

    <div class="tab-content" role="tabpanel" aria-hidden="false">
      <div class="search-container">
        <div class="search-field">
          <label class="user_id"for="userId">User ID:</label>
          <span class="p-input-icon-right">
            <i class="pi pi-search"></i>
            <input
            [maxLength]="100"
              pInputText
              id="userId"
              type="text"
              [(ngModel)]="searchUserId"
              (ngModelChange)="onSearchInputChange()"
              (keydown.enter)="searchUser()"
              placeholder="Enter user ID/Name"
            />
          </span>
          <button
            pButton
            label="Search User"
            (click)="searchUser()"
            class="btn-primary h-30"
          ></button>
        </div>

        <div
          *ngIf="showUserDetails && selectedUser"
          class="user-verification-results"
        >
          <div class="user-info">
            <div class="info-row">
              <span>Email:</span>
              <span>{{ selectedUser.email || "N/A" }}</span>
            </div>
            <div class="info-row">
              <span>Full Name:</span>
              <span>{{ selectedUser.name || "N/A" }}</span>
            </div>
            <div class="info-row">
              <span>Phone:</span>
              <span>{{ selectedUser.phone || "N/A" }}</span>
            </div>
          </div>

          <div class="roles-selection">
            <div class="roles-label">Roles:</div>

            <div class="role-checkboxes">
              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.administrator"
                  [binary]="true"
                  id="admin"
                ></p-checkbox>
                <label for="admin">Administrator</label>
              </div>

              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.inspections"
                  [binary]="true"
                  id="inspections"
                ></p-checkbox>
                <label for="inspections">Inspections</label>
              </div>

              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.oa"
                  [binary]="true"
                  id="oa"
                ></p-checkbox>
                <label for="oa">OA</label>
              </div>

              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.airCompliance"
                  [binary]="true"
                  id="airCompliance"
                ></p-checkbox>
                <label for="airCompliance">Air Compliance</label>
              </div>

              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.leadEngineer"
                  [binary]="true"
                  id="leadEngineer"
                ></p-checkbox>
                <label for="leadEngineer">Lead Engineer</label>
              </div>

              <div class="role-item">
                  <p-checkbox
                  [(ngModel)]="selectedUser.operator"
                  [binary]="true"
                  id="operator"
                ></p-checkbox>
                <label for="operator">Operator</label>
              </div>

              <div class="role-item">
                <p-checkbox
                  [(ngModel)]="selectedUser.engineer"
                  [binary]="true"
                  id="engineering"
                ></p-checkbox>
                <label for="engineering">Engineering</label>
              </div>
            </div>
          </div>

          <div class="save-changes">
            <button (click)="saveChanges()" class="btn-primary">
              Save Changes
            </button>
          </div>
        </div>
      </div>

      <!-- PrimeNG ProgressSpinner for table data loading -->
      

      <!-- User table - only show when not loading and not showing user details -->
      <p-table
        *ngIf="!showUserDetails && !isDataLoading"
        [value]="filteredUsers"
        id="StyleTable"
        styleClass="p-datatable-gridlines"
        scrollHeight="600px"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>User ID</th>
            <th>Name</th>
            <th class="align-center">Administrator</th>
            <th class="align-center">Inspections</th>
            <th class="align-center">OA</th>
            <th class="align-center">Operator</th>
            <th class="align-center">Air Compliance</th>
            <th class="align-center">Lead Engineer</th>
            <th class="align-center">Engineer</th>
            <th class="align-center">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
          <tr>
            <td>{{ user.userId }}</td>
            <td>{{ user.name }}</td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.administrator"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.inspections"
                [binary]="true"
              ></p-checkbox>
            </td>

            <td class="checkbox-cell align-center">
              <p-checkbox [(ngModel)]="user.oa" [binary]="true"></p-checkbox>
            </td>

            <td class="checkbox-cell align-center">
              <p-checkbox [(ngModel)]="user.operator" [binary]="true"></p-checkbox>
            </td>
            

            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.airCompliance"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.leadEngineer"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td class="checkbox-cell align-center">
              <p-checkbox
                [(ngModel)]="user.engineer"
                [binary]="true"
              ></p-checkbox>
            </td>
            <td class="align-center">
                <div class="button-wrapper d-flex gap-2">
              <button
                pButton
                label="Update"
                (click)="updateUser(user)"
                class="primary-btn h-30"
              ></button>
              <button
                pButton
                (click)="deleteUser(user)"
                class="cancel-btn ml-10 h-30"
              >
                Delete User
              </button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr *ngIf="noResultsFound">
            <td colspan="10" class="empty-message">
              No users found matching "{{ prevSearchUserId }}". Please try another
              search.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="tab-content" role="tabpanel" aria-hidden="true">
      <div class="add-user-form">
        <span class="tabheading">User ID Verification</span>
        <div class="ml-20">
          <div class="user-id-verification">
            <div class="form-row">
              <label for="newUserId">User ID:</label>              <input
                pInputText
                [maxLength]="100"
                id="newUserId"
                type="text"
                [(ngModel)]="newUserId"
                (keydown.enter)="verifyUserId()"
                (input)="onUserIdInputChange()"
                class="user-id-input"
              />
              <div class="verification-buttons">
                <button pButton class="btn-primary h-30" (click)="verifyUserId()">
                  Verify User ID, View Roles
                </button>
                <button pButton class="cancel-btn h-30" (click)="clearUserId()">
                  Clear User ID
                </button>
              </div>            </div>
           
            <!-- Display message when input field is empty on verify click -->
            <p *ngIf="showEmptyFieldMessage" class="verification-message">
              Please type in a CAI or Email
            </p>
              <!-- Display message when user already exists -->
            <p *ngIf="userExists" class="verification-message">
              User ID already Exists
            </p>
              <!-- Display message when user is not valid -->
            <p *ngIf="userNotValid" class="verification-message">
              User is Not Valid
            </p>

            <!-- Display user information when verified -->
            <div *ngIf="userVerified && !userExists" class="user-info-display">
              <p class="user-email">
                <span>Email: </span>{{ newUserRoles.email }}
              </p>
              <p class="user-name">
                <span>Full Name: </span>{{ newUserRoles.name }}
              </p>
              <p class="user-phone">
                <span>Phone: </span>{{ newUserRoles.phone || "" }}
              </p>
            </div>
          </div>

          <!-- Only show role selection for new users -->
          <div *ngIf="userVerified && !userExists" class="user-roles-section">
            <p >
              User ID verified. Please select roles for this user:
            </p>

            <div class="roles-horizontal-container">
              <div class="role-item">
                <label>Administrator:</label>
                <p-checkbox
                  [(ngModel)]="newUserRoles.administrator"
                  [binary]="true"
                ></p-checkbox>
              </div>

              <div class="role-item">
                <label>Inspections:</label>
                <p-checkbox
                  [(ngModel)]="newUserRoles.inspections"
                  [binary]="true"
                ></p-checkbox>
              </div>

              <div class="role-item">
                <label>OA:</label>
                <p-checkbox
                  [(ngModel)]="newUserRoles.oa"
                  [binary]="true"
                ></p-checkbox>
              </div>

                 <div class="role-item">
                <label>Operator:</label>
                <p-checkbox
                  [(ngModel)]="newUserRoles.operator"
                  [binary]="true"
                ></p-checkbox>
              </div>

              <div class="role-item">
                <label>Air Compliance:</label>
                <p-checkbox
                  [(ngModel)]="newUserRoles.airCompliance"
                  [binary]="true"
                ></p-checkbox>
              </div>

              <div class="role-item">
                <label>Lead Engineer:</label>
                <p-checkbox
                  [(ngModel)]="newUserRoles.leadEngineer"
                  [binary]="true"
                ></p-checkbox>
              </div>

              <div class="role-item">
                <label>Engineer:</label>
                <p-checkbox
                  [(ngModel)]="newUserRoles.engineer"
                  [binary]="true"
                ></p-checkbox>
              </div>
            </div>

            <div class="add-user-action">
              <button pButton class="btn-primary h-30" (click)="addUser()">
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </np-tabbed>
</div>
